<h2 class="title-white title-fixed">
    <ng-container i18n *ngIf="hurryUp">Hurry up</ng-container>
    <ng-container *ngIf="!hurryUp">
        <ng-content></ng-content>
    </ng-container>
</h2>

@if (ballShootIn && !isClosed) {
    <h2 class="phase-label yellow" i18n>Ball shoot in</h2>
} @else if (hurryUp) {
    <h2 class="phase-label orange" i18n>Preparation time</h2>
} @else if (!isClosed) {
    <h2 class="phase-label green" i18n>Game betting time</h2>
} @else if (isClosed) {
    <h2 i18n class="phase-label">Wait for result</h2>
} @else {
    <div class="phase-label">&nbsp;</div>
}

<div class="timer-wrapper">
    <app-loader
        [progress]="progress"
        [isClosed]="isClosed"
        [bettingTimeInSeconds]="bettingWindowInSeconds"
        [hurryUpTimeInSeconds]="preparationTimeInSeconds"
        [ballShootInTimeInSeconds]="betsOpenAfterBallThrowInSeconds"
    ></app-loader>
</div>
